import { render } from "./AuditFormBlock.vue?vue&type=template&id=96582c22&ts=true"
import script from "./AuditFormBlock.vue?vue&type=script&lang=ts"
export * from "./AuditFormBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__